import emailjs from "emailjs-com"

export const sendFooterClickMail = (name: string) => {
  emailjs.send(
    "service_vplp4km",
    "template_hx4xcxe",
    {
      name,
      time: new Date().toLocaleString(),
    },
    "G-el5qBtrhQiP5uxd"
  ).catch(err => {
    console.error("EmailJS error:", err)
  })
}

export const sendFooterClickMailFerni = (name: string) => {
  emailjs.send(
    "service_vplp4km",
    "template_fjlmvuo",
    {
      name,
      time: new Date().toLocaleString(),
    },
    "G-el5qBtrhQiP5uxd"
  ).catch(err => {
    console.error("EmailJS error:", err)
  })
}